import React from 'react';
import { AutoLinkPlugin as LexicalAutoLinkPlugin } from '@lexical/react/LexicalAutoLinkPlugin';
import { LinkPlugin as LexicalLinkPlugin } from '@lexical/react/LexicalLinkPlugin';

const URL_MATCHER =
  /(((https?:\/\/(www\.)?)|(www\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*))/;

const EMAIL_MATCHER =
  /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;

export const HOUR_DURATION_MATCHER = /0?([0-9][0-9]?):([0-9][0-9]?):[0-5][0-9]/;

export const MIN_DURATION_MATCHER = /(0?([0-9][0-9]?):[0-5][0-9])/;

const MATCHERS = [
  (text) => {
    const match = URL_MATCHER.exec(text);
    return (
      match && {
        index: match.index,
        length: match[0]?.length,
        text: match[0],
        url: match[0],
      }
    );
  },
  (text) => {
    const match = EMAIL_MATCHER.exec(text);
    return (
      match && {
        index: match.index,
        length: match[0]?.length,
        text: match[0],
        url: `mailto:${match[0]}`,
      }
    );
  },
  (text: string) => {
    const match =
      HOUR_DURATION_MATCHER.exec(text) || MIN_DURATION_MATCHER.exec(text);

    return (
      match && {
        index: match.index,
        length: match[0]?.length,
        text: match[0],
        url: `/time=${match[0]}`,
      }
    );
  },
];

export default function AutoLinkPlugin() {
  return (
    <React.Fragment>
      <LexicalAutoLinkPlugin matchers={MATCHERS} />
      <LexicalLinkPlugin />
    </React.Fragment>
  );
}
